import * as React from "react";

function IconREASolo({ selected = false, ...props }) {
  // Swap colors if selected
  const circleFill = selected ? "#170F49" : "#eeff41";
  const pathFill = selected ? "#eeff41" : "#170F49";
  return (
    <svg width={72} height={72} fill="none" {...props}>
      <circle
        cx={35.625}
        cy={36.375}
        r={34.875}
        fill={circleFill}
      />
      <circle
        cx={35.625}
        cy={36.375}
        r={34.375}
        stroke="#000"
        strokeOpacity={0.16}
      />
      <path
        d="M36 37.179c5.849 0 10.59-4.741 10.59-10.59C46.59 20.741 41.849 16 36 16c-5.848 0-10.589 4.741-10.589 10.59 0 5.848 4.741 10.589 10.59 10.589zM35.912 56c7.686 0 14.36-3.723 17.723-10.08.192-.365-1.803-6.88-10.13-7.552-1.611-.13-4.238 2.072-7.593 2.072-2.746 0-5.4-2.277-7.288-2.072-7.746.835-10.581 7.296-10.245 7.904C21.8 52.437 28.369 56 35.912 56z"
        fill={pathFill}
      />
    </svg>
  );
}

const MemoIconREASolo = React.memo(IconREASolo);
export default MemoIconREASolo;
